import React from 'react';
import { iconProps } from '../Helper';

const PrivacyAndPolicyIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_5069_35962"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5069_35962)">
        <path
          className={className}
          d="M17 17C17.4167 17 17.7708 16.8542 18.0625 16.5625C18.3542 16.2708 18.5 15.9167 18.5 15.5C18.5 15.0833 18.3542 14.7292 18.0625 14.4375C17.7708 14.1458 17.4167 14 17 14C16.5833 14 16.2292 14.1458 15.9375 14.4375C15.6458 14.7292 15.5 15.0833 15.5 15.5C15.5 15.9167 15.6458 16.2708 15.9375 16.5625C16.2292 16.8542 16.5833 17 17 17ZM17 20C17.523 20 17.9996 19.8808 18.4298 19.6423C18.8599 19.4038 19.2115 19.0845 19.4845 18.6845C19.1115 18.4615 18.7167 18.2917 18.3 18.175C17.8833 18.0583 17.45 18 17 18C16.55 18 16.1167 18.0583 15.7 18.175C15.2833 18.2917 14.8885 18.4615 14.5155 18.6845C14.7885 19.0845 15.1401 19.4038 15.5703 19.6423C16.0004 19.8808 16.477 20 17 20ZM12 21.4808C9.83717 20.8909 8.0465 19.6178 6.628 17.6615C5.20933 15.7052 4.5 13.518 4.5 11.1V5.34626L12 2.53851L19.5 5.34626V11.0115C19.2667 10.9167 19.0218 10.8311 18.7653 10.7548C18.5089 10.6786 18.2538 10.6187 18 10.575V6.39051L12 4.15001L6 6.39051V11.1C6 11.9858 6.125 12.8509 6.375 13.6953C6.625 14.5394 6.96958 15.3285 7.40875 16.0625C7.84775 16.7965 8.37242 17.4555 8.98275 18.0395C9.59292 18.6235 10.2551 19.0898 10.9692 19.4385L10.9983 19.4288C11.1302 19.7954 11.3013 20.1468 11.5115 20.4828C11.7218 20.8186 11.9609 21.1237 12.2287 21.398C12.1866 21.4108 12.1485 21.4247 12.1145 21.4395C12.0805 21.4542 12.0423 21.4679 12 21.4808ZM17 21.5C15.7513 21.5 14.6892 21.0622 13.8135 20.1865C12.9378 19.3108 12.5 18.2487 12.5 17C12.5 15.7513 12.9378 14.6892 13.8135 13.8135C14.6892 12.9378 15.7513 12.5 17 12.5C18.2487 12.5 19.3108 12.9378 20.1865 13.8135C21.0622 14.6892 21.5 15.7513 21.5 17C21.5 18.2487 21.0622 19.3108 20.1865 20.1865C19.3108 21.0622 18.2487 21.5 17 21.5Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default PrivacyAndPolicyIcon;
